import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Departamento, Empregador, Funcionario, JornadaPonto } from '../../api.service';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { ServicoFiltroDepartamento } from '../../shared/servico-filtro-departamento';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ModalFuncionarioExportacaoComponent } from '../exportacao/modal-funcionario-exportacao.component';
import { FiltrosPendenciaPontoComponent } from './filtros-pendencia-ponto.component';
import { GradePendenciaPontoComponent } from './grade-pendencia-ponto.component';
import { LinhaPendenciaPonto, ServicoPendenciaPonto } from './servico-pendencia-ponto';

@Component({
  selector: 'app-tela-pendencia-ponto',
  standalone: true,
  imports: [CommonModule, FiltrosPendenciaPontoComponent, GradePendenciaPontoComponent, ModalFuncionarioExportacaoComponent],
  templateUrl: './tela-pendencia-ponto.component.html'
})
export class TelaPendenciaPontoComponent implements OnChanges, OnInit {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() funcionarios: Funcionario[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() jornadas: JornadaPonto[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();

  funcionarioSelecionado = '';
  departamentoSelecionado: string[] = [];
  buscaFuncionario = '';
  buscaFuncionarioModal = '';
  dataInicial = this.servicoPendenciaPonto.filtroPadrao().dataInicial;
  dataFinal = this.servicoPendenciaPonto.filtroPadrao().dataFinal;
  linhas: LinhaPendenciaPonto[] = [];
  pesquisado = false;
  modalFuncionariosAberta = false;

  constructor(
    private readonly servicoBuscaCadastro: ServicoBuscaCadastro,
    private readonly servicoPendenciaPonto: ServicoPendenciaPonto,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoFiltroDepartamento: ServicoFiltroDepartamento
  ) {}

  ngOnInit() {
    this.aplicarFiltroPadrao();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado'] && !changes['empregadorSelecionado'].firstChange) {
      this.limpar();
    }

    if (this.funcionarioSelecionado && !this.funcionarios.some(item => item.id === this.funcionarioSelecionado)) {
      this.limparFuncionario();
    }
  }

  get funcionariosFiltrados() {
    return this.servicoBuscaCadastro.filtrarFuncionarios(
      this.funcionariosPorDepartamento,
      this.buscaFuncionario,
      this.funcionarioSelecionado
    );
  }

  get funcionariosPorDepartamento() {
    return this.servicoFiltroDepartamento.funcionariosNoRecorte(
      this.funcionarios,
      this.departamentoSelecionado,
      this.departamentos
    );
  }

  get departamentoIdsConsulta() {
    return this.servicoFiltroDepartamento.consulta(this.departamentoSelecionado, this.departamentos.length);
  }

  get funcionariosModal() {
    return this.servicoBuscaCadastro.listarFuncionariosModal(this.funcionariosPorDepartamento, this.buscaFuncionarioModal);
  }

  alterarDepartamento(departamentoIds: string[]) {
    this.departamentoSelecionado = departamentoIds;
    if (this.funcionarioSelecionado && !this.funcionariosPorDepartamento.some(item => item.id === this.funcionarioSelecionado)) {
      this.limparFuncionario();
      return;
    }
    this.limparResultado();
  }

  get empregadorAtual() {
    return this.empregadores.find(empregador => empregador.id === this.empregadorSelecionado);
  }

  rotuloFuncionario = (item: unknown) => this.servicoBuscaCadastro.rotuloFuncionario(item);

  detalheFuncionario = (item: unknown) => this.servicoBuscaCadastro.detalheFuncionario(item);

  alterarBuscaFuncionario(valor: string) {
    this.buscaFuncionario = valor;
    if (!valor.trim()) {
      this.limparFuncionario();
      return;
    }

    if (valor.trim().length < 3) {
      this.funcionarioSelecionado = '';
      this.limparResultado();
      return;
    }

    if (this.funcionariosFiltrados.length === 1) {
      this.selecionarFuncionario(this.funcionariosFiltrados[0], false);
    }
  }

  abrirModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = true;
  }

  fecharModalFuncionarios() {
    this.modalFuncionariosAberta = false;
  }

  selecionarFuncionario(item: unknown, fecharModal = true) {
    const funcionario = item as Funcionario;
    this.funcionarioSelecionado = funcionario.id || '';
    this.buscaFuncionario = this.rotuloFuncionario(funcionario);
    this.buscaFuncionarioModal = '';
    this.limparResultado();
    if (fecharModal) {
      this.fecharModalFuncionarios();
    }
  }

  limparFuncionario() {
    this.funcionarioSelecionado = '';
    this.buscaFuncionario = '';
    this.buscaFuncionarioModal = '';
    this.limparResultado();
  }

  limparBuscaFuncionarioModal() {
    this.buscaFuncionarioModal = '';
  }

  imprimir() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoPendenciaPonto.mensagemEmpregadorObrigatorio());
      return;
    }

    const abaPdf = window.open('', '_blank');
    if (!abaPdf) {
      this.mensagem.emit(this.servicoPendenciaPonto.mensagemErroAbrirPdf());
      return;
    }

    this.servicoPendenciaPonto.baixarPendenciasPdf(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      this.funcionarioSelecionado || undefined,
      this.departamentoIdsConsulta
    ).subscribe({
      next: blob => {
        this.servicoPendenciaPonto.abrirPdfEmNovaAba(blob, abaPdf);
        this.mensagem.emit(this.servicoPendenciaPonto.mensagemPdfGerado());
      },
      error: erro => {
        abaPdf.close();
        this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao gerar relatorio de pendencias em PDF.'));
      }
    });
  }

  pesquisar() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoPendenciaPonto.mensagemEmpregadorObrigatorio());
      return;
    }

    this.servicoPendenciaPonto.pesquisar(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      this.funcionarioSelecionado,
      this.departamentoIdsConsulta
    ).subscribe({
      next: linhas => {
        this.linhas = linhas;
        this.pesquisado = true;
      },
      error: () => this.mensagem.emit(this.servicoPendenciaPonto.mensagemErroPesquisar())
    });
  }

  limpar() {
    this.funcionarioSelecionado = '';
    this.departamentoSelecionado = [];
    this.buscaFuncionario = '';
    this.buscaFuncionarioModal = '';
    this.aplicarFiltroPadrao();
    this.limparResultado();
  }

  private aplicarFiltroPadrao() {
    const filtro = this.servicoPendenciaPonto.filtroPadrao();
    this.dataInicial = filtro.dataInicial;
    this.dataFinal = filtro.dataFinal;
  }

  private limparResultado() {
    this.linhas = [];
    this.pesquisado = false;
  }
}
